import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    UpdateBillingDetailsRequest, UpdateBillingDetailsResponse,
    CalculateTaxAmountRequest, CalculateTaxAmountResponse
} from "./types";

export { apiName };

const updateBillingDetails = getCallable<UpdateBillingDetailsRequest, UpdateBillingDetailsResponse>(
    apiName,
    "updateBillingDetails",
    {
        ...endpoints.updateBillingDetails,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/customers/billing-details`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const calculateTaxAmount = getCallable<CalculateTaxAmountRequest, CalculateTaxAmountResponse>(
    apiName,
    "calculateTaxAmount",
    {
        ...endpoints.CalculateTaxAmount,
        composer: request => {
            return {
                url: `/workspaces/${request.stripeProductId}/billing/calculated-taxes`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

export const callables = {
    updateBillingDetails,
    calculateTaxAmount
};
